module.exports = __webpack_public_path__ + "img/logo-full.0d16e416.png";